module.exports = __webpack_public_path__ + "img/紫泡泡球_0044.7d1ba2d5.png";